import { IAction } from '../../../../../__core/Interfaces/IAction';
import { setLecturerGrantForModuleInProgressInitState } from './InitState';
import SHARING_ACTIONS from '../Actions/ActionTypes';
import { ISetLecturerGrantForModule } from '../Interfaces/ISetLecturerGrantForModule';

export const setLecturerGrantForModuleInProgressReducer = (
  state: Array<ISetLecturerGrantForModule> = setLecturerGrantForModuleInProgressInitState,
  action: IAction<ISetLecturerGrantForModule>
): Array<ISetLecturerGrantForModule> => {
  switch (action.type) {
    case SHARING_ACTIONS.SET_LECTURER_GRANT_FOR_MODULE_START:
      return [...state, action.payload];

    case SHARING_ACTIONS.SET_LECTURER_GRANT_FOR_MODULE_FINISH:
      return [
        ...state.filter(
          (value) =>
            value.moduleNumber !== action.payload.moduleNumber &&
            value.lecturerId !== action.payload.lecturerId
        ),
      ];

    default:
      return state;
  }
};
